// @ts-nocheck
//TODO: odstranit ts-nocheck

import React, { useState } from 'react';

const BCPCalculator = () => {
  // Stavové proměnné pro formulář
  const [weight, setWeight] = useState('');
  const [age, setAge] = useState('');
  const [issues, setIssues] = useState([]);
  const [medications, setMedications] = useState('');
  const [email, setEmail] = useState('');
  const [results, setResults] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [emailConsent, setEmailConsent] = useState(false);

  // Seznam potíží a jejich doporučené dávkování (kapky 20% BCP v hroznovém oleji)
  const issuesList = [
    { id: 1, name: "Chronická bolest", dose: 3 },
    { id: 2, name: "Zánětlivá onemocnění", dose: 4 },
    { id: 3, name: "Úzkost", dose: 2 },
    { id: 4, name: "Poruchy spánku", dose: 2 },
    { id: 5, name: "Sportovní regenerace", dose: 3 },
    { id: 6, name: "Migrény", dose: 3 },
    { id: 7, name: "Trávicí potíže", dose: 2 },
    { id: 8, name: "Kožní problémy", dose: 2 },
    { id: 9, name: "Stres", dose: 2 },
    { id: 10, name: "Autoimunitní onemocnění", dose: 4 }
  ];

      // Společný seznam léků pro nápovědu a kontrolu kontraindikací
  const commonMedications = [
    // Léky ovlivňující srážlivost krve
    { name: "Warfarin", contraindicated: true },
    { name: "Anopyrin", contraindicated: false },
    { name: "Godasal", contraindicated: false },
    { name: "Aspirin", contraindicated: false },
    { name: "Eliquis", contraindicated: true },
    { name: "Pradaxa", contraindicated: true },
    { name: "Xarelto", contraindicated: true },
    
    // Imunosupresiva
    { name: "Cyklosporin", contraindicated: true },
    { name: "Takrolimus", contraindicated: true },
    { name: "Prednison", contraindicated: false },
    { name: "Methotrexát", contraindicated: false },
    
    // Statiny
    { name: "Simvastatin", contraindicated: true },
    { name: "Atorvastatin", contraindicated: true },
    { name: "Rosuvastatin", contraindicated: true },
    { name: "Lovastatin", contraindicated: true },
    
    // Benzodiazepiny a anxiolytika
    { name: "Midazolam", contraindicated: true },
    { name: "Alprazolam", contraindicated: true },
    { name: "Diazepam", contraindicated: true },
    { name: "Neurol", contraindicated: true },
    { name: "Xanax", contraindicated: true },
    { name: "Lexaurin", contraindicated: true },
    
    // Opioidy a analgetika
    { name: "Fentanyl", contraindicated: true },
    { name: "Oxykodon", contraindicated: true },
    { name: "Tramadol", contraindicated: true },
    { name: "Tramal", contraindicated: true },
    { name: "Novalgin", contraindicated: false },
    { name: "Ibalgin", contraindicated: false },
    { name: "Paracetamol", contraindicated: false },
    { name: "Paralen", contraindicated: false },
    
    // Antihypertenziva
    { name: "Concor", contraindicated: false },
    { name: "Prestarium", contraindicated: false },
    { name: "Tensiomin", contraindicated: false },
    { name: "Lorista", contraindicated: false },
    
    // Antidiabetika
    { name: "Metformin", contraindicated: false },
    { name: "Siofor", contraindicated: false },
    { name: "Januvia", contraindicated: false },
    
    // Další běžné léky
    { name: "Euthyrox", contraindicated: false },
    { name: "Helicid", contraindicated: false },
    { name: "Omeprazol", contraindicated: false },
    { name: "Pantoprazol", contraindicated: false },
    { name: "Algifen", contraindicated: false },
    { name: "Xyzal", contraindicated: false },
    { name: "Zodac", contraindicated: false },
    { name: "Zyrtec", contraindicated: false }
  ];
  
  // Extrahování léků s kontraindikací pro kontrolu
  const medicationContraindications = commonMedications
    .filter(med => med.contraindicated)
    .map(med => med.name.toLowerCase());
  
  // Zdravotní stavy, při kterých je BCP kontraindikováno
  const healthContraindications = [
    "Těhotenství a kojení",
    "Závažné onemocnění jater",
    "Příprava na chirurgický zákrok (2 týdny před operací)",
    "Nízký krevní tlak",
    "Poruchy srážlivosti krve"
  ];

  // Funkce pro kontrolu kontraindikací
  const checkContraindications = (medsInput) => {
    if (!medsInput) return [];
    
    const userMeds = medsInput.toLowerCase().split(',').map(med => med.trim());
    
    // Kontrola léků podle seznamu kontraindikací
    const contraindicated = [];
    
    for (const userMed of userMeds) {
      // Pokud je uživatelův lék prázdný string, přeskočíme
      if (userMed === '') continue;
      
      // Kontrola přesné shody nebo částečné shody s léky v seznamu
      for (const med of commonMedications) {
        const medLower = med.name.toLowerCase();
        if ((userMed === medLower || userMed.includes(medLower) || medLower.includes(userMed)) && med.contraindicated) {
          contraindicated.push(med.name);
          break;
        }
      }
    }
    
    // Odstranění duplicit
    return [...new Set(contraindicated)];
  };

  //TODO: po vypocitani scrollnout nahoru
  // Výpočet dávkování BCP
  const calculateDosage = () => {
    // Základní kontroly
    if (!weight || !age || issues.length === 0) {
      alert("Prosím vyplňte všechny povinné údaje (váha, věk a alespoň jedna potíž).");
      return;
    }

    const weightNum = parseFloat(weight);
    const ageNum = parseInt(age);
    
    // Kontrola kontraindikací léků
    const medicationContraindicationsList = checkContraindications(medications);
    
    // Kontrola kontraindikací dle zdravotního stavu a věku
    let healthContraindicationsList = [];
    
    // Kontrola věku - děti pod 12 let a těhotné ženy
    if (ageNum < 12) {
      healthContraindicationsList.push("Věk pod 12 let");
    }
    
    // Spojení všech kontraindikací
    const allContraindications = [...medicationContraindicationsList, ...healthContraindicationsList];
    
    // Základní dávka podle váhy (0.1 kapky na kg)
    let baseDose = weightNum * 0.1;
    
    // Úprava podle věku
    if (ageNum > 65) {
      baseDose *= 0.8; // Snížení o 20% pro seniory
    } else if (ageNum < 18 && ageNum >= 12) {
      baseDose *= 0.6; // Snížení o 40% pro mladistvé
    }
    
    // Přidání specifických dávek pro každou vybranou potíž
    let totalAdditionalDose = 0;
    const selectedIssuesDetails = issues.map(issueId => {
      const issue = issuesList.find(i => i.id === parseInt(issueId));
      totalAdditionalDose += issue.dose;
      return issue;
    });
    
    // Celková doporučená dávka (zaokrouhleno na 1 desetinné místo)
    const totalDose = Math.round((baseDose + totalAdditionalDose) * 10) / 10;
    
    // Denní dávkovací schéma
    const morningDose = Math.round(totalDose * 0.4 * 10) / 10;
    const eveningDose = Math.round(totalDose * 0.6 * 10) / 10;
    
    setResults({
      baseDose,
      totalDose,
      morningDose,
      eveningDose,
      contraindications: allContraindications,
      selectedIssues: selectedIssuesDetails
    });
    
    setShowResults(true);
  };

  // Vědecké studie o BCP
  const bcpStudies = [
    {
      title: "β-Caryophyllene, a CB2 receptor agonist produces multiple behavioral changes relevant to anxiety and depression in mice",
      authors: "Bahi A, et al.",
      journal: "Physiol Behav. 2014",
      link: "https://pubmed.ncbi.nlm.nih.gov/24930711/"
    },
    {
      title: "Beta-caryophyllene is a dietary cannabinoid",
      authors: "Gertsch J, et al.",
      journal: "Proc Natl Acad Sci USA. 2008",
      link: "https://pubmed.ncbi.nlm.nih.gov/18574142/"
    },
    {
      title: "Anti-inflammatory activity of β-caryophyllene combined with docosahexaenoic acid in a model of sepsis",
      authors: "Chávez-Hurtado P, et al.",
      journal: "Inflammopharmacology. 2020",
      link: "https://pubmed.ncbi.nlm.nih.gov/31776875/"
    },
    {
      title: "β-Caryophyllene, a CB2-Receptor-Selective Phytocannabinoid, Suppresses Motor Paralysis and Neuroinflammation in a Murine Model of Multiple Sclerosis",
      authors: "Alberti TB, et al.",
      journal: "Int J Mol Sci. 2017",
      link: "https://pubmed.ncbi.nlm.nih.gov/28406270/"
    },
    {
      title: "Antinociceptive effect of the essential oil of Zingiber zerumbet in mice: Possible mechanisms",
      authors: "Khalid MH, et al.",
      journal: "J Ethnopharmacol. 2011",
      link: "https://pubmed.ncbi.nlm.nih.gov/21571058/"
    },
    {
      title: "β-Caryophyllene and β-Caryophyllene Oxide—Natural Compounds of Anticancer and Analgesic Properties",
      authors: "Fidyt K, et al.",
      journal: "Cancer Med. 2016",
      link: "https://pubmed.ncbi.nlm.nih.gov/27696789/"
    },
    {
      title: "Beta-caryophyllene enhances wound healing through multiple routes",
      authors: "Koyama S, et al.",
      journal: "PLoS One. 2019",
      link: "https://pubmed.ncbi.nlm.nih.gov/31860643/"
    },
    {
      title: "β-Caryophyllene ameliorates the Alzheimer-like phenotype in APP/PS1 Mice through CB2 receptor activation and the PPARγ pathway",
      authors: "Cheng Y, et al.",
      journal: "Pharmacology. 2014",
      link: "https://pubmed.ncbi.nlm.nih.gov/25281622/"
    },
    {
      title: "Dietary intake of the endocannabinoid agonist beta-caryophyllene during pregnancy suppresses nephrotoxicity by modulating inflammatory responses and oxidative stress",
      authors: "Fontes LBA, et al.",
      journal: "Chem Biol Interact. 2020",
      link: "https://pubmed.ncbi.nlm.nih.gov/32027887/"
    },
    {
      title: "β-Caryophyllene, a natural sesquiterpene, attenuates neuropathic pain and depressive-like behavior in experimental diabetic mice",
      authors: "Aguilar-Ávila DS, et al.",
      journal: "J Med Food. 2019",
      link: "https://pubmed.ncbi.nlm.nih.gov/31314687/"
    }
  ];

  //TODO: po resetu scrollnout nahoru
  // Reset formuláře
  const resetForm = () => {
    setWeight('');
    setAge('');
    setIssues([]);
    setMedications('');
    setEmail('');
    setResults(null);
    setShowResults(false);
    setEmailConsent(false);
  };

  // Manipulace s výběrem potíží
  const handleIssueToggle = (issueId) => {
    setIssues(prevIssues => {
      if (prevIssues.includes(issueId)) {
        return prevIssues.filter(id => id !== issueId);
      } else {
        return [...prevIssues, issueId];
      }
    });
  };

  return (
    <div className="max-w-4xl mx-auto p-4 bg-gray-50 rounded-lg shadow-md">
      <h1 className="text-3xl font-bold text-center mb-6" style={{ color: '#8b8c8e' }}>Stabla BCP kalkulačka</h1>
      
      {!showResults ? (
        <div className="space-y-6">
          <div className="bg-white p-6 rounded-md shadow">
            <p className="mb-4 text-gray-700">
              Tato kalkulačka vám pomůže určit optimální dávkování beta-karyofylenu (BCP) na základě vaší váhy, věku a zdravotních potíží.
              Beta-karyofylen je přírodní seskviterpen s potenciálními zdravotními benefity podloženými vědeckými studiemi.
            </p>
            <div className="p-3 bg-blue-50 border-l-4 border-blue-300 rounded mb-4">
              <p className="text-blue-800 italic">
                "BCP v hroznovém oleji představuje optimální kombinaci pro maximální biologickou dostupnost 
                této hodnotné přírodní látky v lidském organismu."
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Váha (kg) *</label>
                <input
                  type="number"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                  placeholder="Zadejte vaši váhu v kg"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Věk *</label>
                <input
                  type="number"
                  value={age}
                  onChange={(e) => setAge(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                  placeholder="Zadejte váš věk"
                  required
                />
              </div>
            </div>
            
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">Vyberte vaše potíže (můžete vybrat více): *</label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {issuesList.map((issue) => (
                  <label key={issue.id} className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded">
                    <input
                      type="checkbox"
                      checked={issues.includes(issue.id.toString())}
                      onChange={() => handleIssueToggle(issue.id.toString())}
                      className="rounded text-green-600"
                    />
                    <span>{issue.name}</span>
                  </label>
                ))}
              </div>
            </div>
            
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">Užívané léky (oddělte čárkou)</label>
              <div className="relative">
                <input
                  type="text"
                  value={medications}
                  onChange={(e) => setMedications(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                  placeholder="např. Ibalgin, Paralen, ..."
                  list="medication-suggestions"
                />
                <datalist id="medication-suggestions">
                  {commonMedications.map((med, index) => (
                    <option key={index} value={med.name} />
                  ))}
                </datalist>
              </div>
              <p className="text-sm text-gray-500 mt-1">
                Uveďte názvy léků, které v současnosti užíváte. Začněte psát a zobrazí se vám nápověda.
                {medications.length > 0 && commonMedications.some(med => med.contraindicated && medications.toLowerCase().includes(med.name.toLowerCase())) && (
                  <span className="text-orange-600 ml-1 font-medium">
                    Některé zadané léky mohou mít kontraindikace s BCP.
                  </span>
                )}
              </p>
            </div>
            
            <div className="mb-6">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={emailConsent}
                  onChange={(e) => setEmailConsent(e.target.checked)}
                  className="rounded text-green-600"
                />
                <span className="text-sm text-gray-700">Doporučit BCP kapky? Zanechte email a my vám pošleme nabídku.</span>
              </label>
              
              {emailConsent && (
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-2 mt-2 border border-gray-300 rounded-md"
                  placeholder="Zadejte váš e-mail"
                />
              )}
            </div>
            
            <div className="flex justify-center">
              <button
                onClick={calculateDosage}
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-md transition duration-300"
              >
                Vypočítat
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="space-y-6">
          <div className="bg-white p-6 rounded-md shadow">
            <h2 className="text-2xl font-semibold text-green-700 mb-4">Výsledky kalkulace</h2>
            
            {results.contraindications.length > 0 && (
              <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded">
                <h3 className="text-lg font-medium text-red-700">Upozornění na možné kontraindikace:</h3>
                <p className="text-red-600">
                  Byly zjištěny potenciální kontraindikace: {results.contraindications.join(', ')}.
                  Před užitím BCP se poraďte se svým lékařem.
                </p>
              </div>
            )}
            
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-800 mb-2">Doporučené dávkování 20% BCP v hroznovém oleji:</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-green-50 p-4 rounded-md border border-green-200">
                  <p className="text-sm text-gray-700">Celková denní dávka:</p>
                  <p className="text-2xl font-bold text-green-800">{results.totalDose} kapek</p>
                  <p className="text-sm text-gray-600 mt-1">
                    (přibližně {Math.round(results.totalDose/15 * 10) / 10} ml, což odpovídá {results.totalDose > 15 ? "celému kapátku" : "půl kapátka"})
                  </p>
                </div>
                
                <div className="bg-green-50 p-4 rounded-md border border-green-200">
                  <p className="text-sm text-gray-700">Doporučené dávkování:</p>
                  <p className="text-lg font-medium text-green-800">Ráno: {results.morningDose} kapek</p>
                  <p className="text-sm text-gray-600">(cca {results.morningDose > 15 ? "celé kapátko" : "půl kapátka"})</p>
                  <p className="text-lg font-medium text-green-800 mt-2">Večer: {results.eveningDose} kapek</p>
                  <p className="text-sm text-gray-600">(cca {results.eveningDose > 15 ? "celé kapátko" : "půl kapátka"})</p>
                </div>
              </div>
            </div>
            
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-800 mb-2">Vybrané potíže a jejich specifické dávkování:</h3>
              <ul className="list-disc pl-5 space-y-1">
                {results.selectedIssues.map((issue) => (
                  <li key={issue.id}>
                    <span className="font-medium">{issue.name}</span>: doporučené přidání {issue.dose} kapek
                  </li>
                ))}
              </ul>
              <p className="text-sm text-gray-600 mt-2">
                Základní dávka dle váhy: {Math.round(results.baseDose * 10) / 10} kapek + specifické dávky dle potíží
              </p>
            </div>
            
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-800 mb-2">Způsob užívání:</h3>
              <p className="text-gray-700">
                Doporučujeme užívat kapky sublingválně (pod jazyk) a nechat vstřebat po dobu alespoň 60 sekund před polknutím.
                Pro optimální účinek užívejte ráno nalačno a večer alespoň 2 hodiny po jídle.
              </p>
              <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                <p className="text-gray-800 font-medium">Věděli jste, že?</p>
                <p className="text-gray-700">
                  "BCP v hroznovém oleji se lépe vstřebává díky synergickému účinku mastných kyselin v hroznovém oleji, 
                  které zlepšují biologickou dostupnost beta-karyofylenu v lidském organismu. Několik studií prokázalo, 
                  že lipofilní terpeny jako BCP vykazují až o 30% vyšší biologickou dostupnost, když jsou podávány v kombinaci 
                  s rostlinnými oleji bohatými na nenasycené mastné kyseliny."
                </p>
              </div>
            </div>
            
            {emailConsent && email && (
              <div className="mb-6 p-4 bg-blue-50 border-l-4 border-blue-500 rounded">
                <p className="text-blue-700">
                  Děkujeme za zájem o BCP produkty. Na e-mail <span className="font-medium">{email}</span> vám brzy zašleme informace o našich produktech.
                </p>
              </div>
            )}
            
            <div className="flex justify-center space-x-4">
              <button
                onClick={resetForm}
                className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-6 rounded-md transition duration-300"
              >
                Nový výpočet
              </button>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-md shadow">
            <h2 className="text-2xl font-semibold text-green-700 mb-4">Mohlo by vás zajímat</h2>
            <div className="space-y-4">
              <p className="text-gray-700">
                Beta-karyofylen (BCP) je přírodní terpen, který se nachází v mnoha rostlinách včetně černého pepře, skořice, oregana a konopí.
                Jedná se o selektivní agonista CB2 receptorů endokanabinoidního systému s potenciálními protizánětlivými a analgetickými účinky.
              </p>
              <div className="my-3 p-3 bg-green-50 border border-green-200 rounded-md">
                <p className="font-medium text-gray-800">Kapky obsahují 30 ml roztoku s 20% koncentrací BCP v hroznovém oleji</p>
                <p className="text-sm text-gray-600 mt-1">
                  Každé kapátko pojme přibližně 30 kapek (cca 1 ml). Pro přesnější dávkování si kapky můžete odpočítat 
                  nebo použít orientační množství - půl kapátka (15 kapek) nebo celé kapátko (30 kapek).
                </p>
              </div>
              
              <h3 className="text-lg font-medium text-gray-800">Vědecké studie o beta-karyofylenu:</h3>
              <ul className="space-y-3">
                {bcpStudies.map((study, index) => (
                  <li key={index} className="border-b pb-2">
                    <p className="font-medium">{study.title}</p>
                    <p className="text-sm text-gray-600">{study.authors}</p>
                    <p className="text-sm text-gray-500">{study.journal}</p>
                    <a href={study.link} target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-800 text-sm">
                      PubMed odkaz
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      
      <div className="mt-8">
        <div className="bg-orange-50 p-6 rounded-md shadow mb-4">
          <h2 className="text-xl font-semibold text-orange-700 mb-3">Kdo by neměl užívat BCP?</h2>
          <p className="text-gray-700 mb-3">
            Beta-karyofylen je obecně považován za bezpečnou látku s nízkým rizikem nežádoucích účinků, 
            existují však určité skupiny osob, které by jeho užívání měly konzultovat s lékařem nebo se mu zcela vyhnout:
          </p>
          <ul className="list-disc pl-5 space-y-2 text-gray-700">
            <li><span className="font-medium">Těhotné a kojící ženy:</span> Studie účinků BCP na těhotné ženy jsou omezené, proto je z preventivních důvodů doporučeno se mu vyhnout.</li>
            <li><span className="font-medium">Děti mladší 12 let:</span> Bezpečnost dlouhodobého užívání u dětí nebyla dostatečně prostudována.</li>
            <li><span className="font-medium">Osoby před operací:</span> BCP může ovlivnit krevní srážlivost, proto je doporučeno přerušit užívání nejméně 2 týdny před plánovaným chirurgickým zákrokem.</li>
            <li><span className="font-medium">Pacienti s onemocněním jater:</span> BCP je metabolizován v játrech, proto by osoby s onemocněním jater měly být při jeho užívání opatrné.</li>
            <li><span className="font-medium">Osoby užívající léky metabolizované enzymem CYP450:</span> BCP může interferovat s metabolismem některých léků (např. warfarin, cyklosporin, takrolimus, statiny a některé benzodiazepiny).</li>
            <li><span className="font-medium">Osoby s nízkým krevním tlakem:</span> BCP může mít mírné hypotenzní účinky, což může být problematické pro osoby, které již mají nízký krevní tlak.</li>
            <li><span className="font-medium">Osoby užívající opioidní analgetika:</span> Existují důkazy o interakci BCP s opioidním systémem, což může potenciálně modifikovat účinky opioidních léků.</li>
          </ul>
        </div>

        <div className="text-center text-sm text-gray-500">
          <p>© 2025 Stabla BCP kalkulačka</p>
          <p className="mt-1">
            Upozornění: Tato kalkulačka slouží pouze pro informativní účely a nenahrazuje lékařskou konzultaci.
            Před užitím jakýchkoliv doplňků stravy se poraďte se svým lékařem.
          </p>
          <p>
            Icons by <a href="https://icons8.com/" className="underline" target="_blank">Icons8</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BCPCalculator;
